var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoenixIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 78,
    viewBox: "0 0 222 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_69_13925)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2618 0C27.3657 14.0009 31.2295 27.1659 36.0615 34.6422C37.6603 36.833 37.5911 36.8024 39.869 39.6728C40.2407 40.1492 40.6124 40.6384 40.984 41.1405C47.203 48.9461 50.6736 57.7822 43.1793 71.6227C63.5518 49.6043 38.5721 25.7718 35.2618 0Z",
    fill: "url(#paint0_linear_69_13925)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7934 19.8753C25.1485 40.4866 29.5481 40.9415 37.8765 48.1189C46.0836 55.0239 44.6441 63.9597 42.1249 71.7305C56.7542 45.4389 30.8235 37.4863 22.7939 19.8753H22.7934Z",
    fill: "url(#paint1_linear_69_13925)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7565 75.9388C13.7785 74.2592 5.11337 64.9859 0.000402381 53.3792C-0.103112 73.5012 23.3593 81.4281 39.6266 74.9646C37.8808 75.493 36.0309 75.8696 34.1468 76.0686C31.6876 76.3325 29.1679 76.3025 26.7565 75.9388Z",
    fill: "url(#paint2_linear_69_13925)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2427 62.4143C14.6517 75.5665 30.8321 77.5578 41.2909 73.4584C28.8225 77.1163 18.8481 72.0556 13.2427 62.4143Z",
    fill: "url(#paint3_linear_69_13925)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.638 41.0659C65.9605 39.8241 64.4673 37.6773 63.215 35.0187C62.9645 37.2809 63.0192 39.5736 64.2598 41.2789C61.9449 41.8502 59.6569 43.1242 57.7266 45.0151C58.3402 54.6001 56.456 63.596 46.8833 70.8083C63.1501 62.4792 60.7821 50.6214 67.6967 47.6989C71.1454 46.1406 74.3956 47.4264 76.8934 51.1058C76.0964 44.896 72.675 41.7225 68.638 41.0654V41.0659Z",
    fill: "url(#paint4_linear_69_13925)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.3079 3.87468C46.9568 11.9662 42.5658 16.4122 47.3065 32.5341C51.5243 43.3136 54.2168 53.7386 49.5409 63.8643C48.5986 66.0637 47.2936 68.2153 45.5564 70.302L45.535 70.3278C45.2759 70.6394 45.0034 70.9511 44.7267 71.2628C70.1344 54.1882 46.7621 25.4076 54.3079 3.87415V3.87468Z",
    fill: "url(#paint5_linear_69_13925)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5081 48.7659C97.556 48.7659 96.6872 48.6414 95.6526 48.4349C95.6939 50.1735 95.7352 54.5191 95.7352 56.5473C95.9422 57.5408 98.0114 57.7892 99.1286 57.9544V58.4098H87.21V57.9544C88.4929 57.8305 90.6034 57.1267 90.6034 56.2158V34.1959C90.6034 33.7817 90.5621 33.5752 90.1894 33.3269C89.6927 33.0372 88.2446 32.416 87.5822 32.1263V31.878L95.4037 28.6079H95.652V33.285L95.6933 33.3676C97.1833 31.2981 99.2938 28.6492 102.314 28.6492C107.363 28.6492 109.764 33.4089 109.764 37.6306C109.764 44.129 105.584 48.7648 98.5075 48.7648L98.5081 48.7659ZM99.3769 32.2095C97.2251 32.2095 95.6939 33.7823 95.6939 34.279C95.6939 34.9415 95.6113 37.0524 95.6113 37.9627C95.6113 39.3284 95.6526 40.9844 95.7352 42.2676C95.9422 44.8338 97.2664 47.9795 99.5427 47.9795C102.15 47.9795 104.343 44.1713 104.343 39.2458C104.343 35.3964 102.77 32.2095 99.3769 32.2095Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.559 48.8072V48.3518C123.049 48.2691 124.207 47.7724 124.207 46.9029V37.1344C124.207 34.2372 123.379 31.9606 120.896 31.9606C119.158 31.9606 118.165 32.6231 117.668 33.3676C117.545 33.5334 117.461 34.0301 117.461 34.485V46.9023C117.461 47.9371 118.703 48.2268 119.82 48.3925V48.8066H109.847V48.3925C111.13 48.2681 112.371 47.7719 112.371 46.7371V24.3035C112.371 23.8894 112.33 23.7242 111.957 23.4345C111.502 23.0622 110.592 22.6894 109.888 22.2758V22.0275L117.172 18.7574H117.503L117.378 33.0785L117.461 33.1198C118.206 31.754 120.606 28.6497 124.537 28.6497C128.179 28.6497 129.338 31.3399 129.338 34.9823V47.0268C129.338 47.8545 130.869 48.3099 131.821 48.4338V48.8061H121.557L121.559 48.8072Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.464 49.0968C136.995 49.0968 131.284 45.8267 131.284 38.8317C131.284 33.492 135.298 28.6497 141.546 28.6497C146.264 28.6497 151.603 31.9611 151.603 38.8317C151.603 44.5849 147.216 49.0968 141.464 49.0968ZM141.34 29.3122C138.443 29.3122 136.871 34.0306 136.871 38.8735C136.871 43.7164 138.112 48.4349 141.588 48.4349C145.064 48.4349 146.016 42.6403 146.016 38.7909C146.016 34.9415 144.899 29.3127 141.34 29.3127V29.3122Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.825 49.0143C155.617 49.0143 151.934 44.2132 151.934 38.3769C151.934 33.6997 155.41 28.6503 161.245 28.6503C165.798 28.6503 169.356 30.8024 169.646 35.5627H157.066C157.024 36.0182 157.024 36.4318 157.024 36.8046C157.024 41.6056 159.631 45.248 163.894 45.248C166.377 45.248 169.026 43.9236 169.687 41.854L170.101 41.9366C169.563 44.5029 167.205 49.0143 161.825 49.0143ZM160.914 29.3535C158.514 29.3535 157.189 33.4513 157.106 34.9829C159.051 34.9829 159.879 34.9002 161.948 34.8171C162.279 34.8171 162.9 34.7345 163.314 34.5274C163.686 34.1551 163.852 33.741 163.852 33.0372C163.852 31.2573 162.817 29.3535 160.914 29.3535Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.026 48.8072V48.3517C182.516 48.2691 183.509 47.7724 183.509 46.9028V37.1344C183.509 34.4442 182.641 32.1263 180.157 32.1263C178.874 32.1263 177.757 32.623 176.888 33.5752V46.986C177.095 48.0621 178.046 48.2278 179.164 48.393V48.8072H169.439V48.393C170.722 48.2686 171.798 47.6066 171.798 46.7376V33.4926C171.798 33.0785 171.757 32.8719 171.384 32.6236C170.887 32.3339 170.101 31.9611 169.439 31.6714V31.423L176.599 28.6084H176.847V33.1198L176.93 33.2024C178.254 31.2567 180.53 28.6491 183.675 28.6491C186.82 28.6491 188.641 31.298 188.641 35.023V47.0262C188.641 47.8539 190.255 48.3093 191.207 48.4333V48.8055H181.027L181.026 48.8072Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.337 48.8072V48.3931C191.62 48.2687 193.151 47.7725 193.151 46.7377V33.534C193.151 33.1198 193.11 32.7476 192.737 32.4992C192.241 32.1682 191.454 31.7954 190.668 31.547V31.2987L197.993 28.6085H198.241V46.8616C198.241 47.8964 199.855 48.31 200.89 48.3931V48.8072H190.337H190.337ZM195.51 26.0009C193.938 26.0009 192.531 24.5938 192.531 23.021C192.531 21.3237 193.855 20.0824 195.51 20.0824C197.165 20.0824 198.49 21.3243 198.49 23.021C198.49 24.7177 197.124 26.0009 195.51 26.0009Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.83 33.1616C214.174 35.1073 213.76 35.7692 212.519 37.342C213.884 39.9909 215.292 42.3502 216.781 44.8338C218.643 48.0621 219.471 48.2691 221.25 48.3523V48.8077H209.87V48.3523C210.408 48.311 211.567 48.3936 211.815 47.0278C211.649 45.7034 210.16 42.8887 208.959 40.9018C207.428 42.9713 205.111 45.9931 205.111 46.9034C205.276 47.8137 206.104 48.3104 207.552 48.3523V48.8077H199.482V48.3523C200.889 48.311 202.296 48.0213 204.862 45.0822C206.394 43.3436 207.718 41.5643 208.587 40.3224C207.014 37.5491 205.607 35.0246 203.993 32.2926C203.538 31.5062 203.207 31.0921 202.834 30.6372C201.8 29.8508 200.641 29.685 199.565 29.5198V29.0644H211.277V29.5198C210.821 29.5611 209.621 29.6855 209.166 30.6372C209.249 31.2165 210.697 34.1551 212.187 36.8045C213.842 34.5692 215.746 31.9203 215.829 31.0513C215.788 30.0991 214.877 29.6024 213.346 29.5198V29.0644H221.168V29.5198C219.471 29.6856 218.685 29.7682 215.829 33.1622L215.83 33.1616Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_69_13925",
    x1: 1.32675,
    y1: -9.45138,
    x2: 70.6292,
    y2: 73.3014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBDA61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FBC671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FE78B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5ACD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_69_13925",
    x1: -7.5653,
    y1: -2.00468,
    x2: 61.7371,
    y2: 80.7481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBDA61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FBC671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FE78B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5ACD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_69_13925",
    x1: -26.0761,
    y1: 13.4977,
    x2: 43.2263,
    y2: 96.2504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBDA61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FBC671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FE78B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5ACD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_69_13925",
    x1: -22.422,
    y1: 10.4373,
    x2: 46.881,
    y2: 93.1896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBDA61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FBC671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FE78B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5ACD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_69_13925",
    x1: 3.1691,
    y1: -10.9942,
    x2: 72.4715,
    y2: 71.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBDA61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FBC671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FE78B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5ACD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_69_13925",
    x1: 6.5143,
    y1: -13.7959,
    x2: 75.8173,
    y2: 68.9569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBDA61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FBC671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FE78B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5ACD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_69_13925"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 221.25,
    height: 77.1675,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoenixIcon);
export default __webpack_public_path__ + "static/media/phoenix_icon.32c1d75f1c357ff312caa422c3637327.svg";
export { ForwardRef as ReactComponent };